import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PreOrdersComponent } from "../pre-orders/pre-orders.component";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TruckOwnerService } from "../truck-owner.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-pre-order-bid-rate",
  templateUrl: "./pre-order-bid-rate.component.html",
  styleUrls: ["./pre-order-bid-rate.component.css"]
})
export class PreOrderBidRateComponent implements OnInit {
  bidForm!: FormGroup;
  token: any;
  isLoading = false;
  lastValidValue: string = '';

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<PreOrderBidRateComponent>,
    private service: TruckOwnerService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.bidForm = this.fb.group({
      rate: ['', [Validators.required, Validators.pattern('^[0-9]+$')]]
    });
    if (this.data?.mode === 'edit' && this.data?.bid_rate) {
      this.bidForm.patchValue({
        rate: this.data.bid_rate
      });
    }
  }


  closeDialog(): void {
    this.dialogRef.close();
  }

  submitBid() {
    if (this.bidForm.valid) {
      const price = Number(this.bidForm.value.rate);
      // Validation: Price/MT should not be less than 1
      if (price < 1) {
        this.snackBar.open("Price/MT should not be less than 1", "Fail", {
          duration: 5000,
        });
        return;
      }

      // Base Price restriction
      if (this.data?.base_price && price >= this.data.base_price) {
        this.snackBar.open(`Your bid must be lower than (Rs. ${this.data.base_price})`, "Fail", {
          duration: 5000,
        });
        return;
      }

      // Lowest Bid Rate restriction
      if (this.data?.lowest_bid_rate && price >= this.data.lowest_bid_rate) {
        this.snackBar.open(`Your bid must be lower than the current Lowest Bid Rate (Rs. ${this.data.lowest_bid_rate})`, "Fail", {
          duration: 5000,
        });
        return;
      }
      this.isLoading = true; // Start loader
      const payload = {
        bid_rate: price,
        workorder_id: this.data.workorder_id?._id || this.data.workorder_id,
      };
      this.service.addPreOrderBidRate(payload, this.token).subscribe(
        (response: any) => {
          this.isLoading = false;
          this.dialogRef.close({ event: "Success", acceptBid: true });
        },
        (error: any) => {
          this.isLoading = false;
          if (error.status == 404) return;
          if (
            error.error.message === "jwt malformed" ||
            error.error.message === "jwt expired"
          ) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
            return;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  resubmitBid() {
    if (this.bidForm.valid) {
      const price = Number(this.bidForm.value.rate);
      if (price < 1) {
        this.snackBar.open("Price/MT should not be less than 1", "Fail", {
          duration: 5000,
        });
        return;
      }

      // Base Price restriction
      if (this.data?.base_price && price >= this.data.base_price) {
        this.snackBar.open(`Your bid must be lower than (Rs. ${this.data.base_price})`, "Fail", {
          duration: 5000,
        });
        return;
      }

      // Lowest Bid Rate restriction
      if (this.data?.lowest_bid_rate && price >= this.data.lowest_bid_rate) {
        this.snackBar.open(`Your bid must be lower than the current Lowest Bid Rate (Rs. ${this.data.lowest_bid_rate})`, "Fail", {
          duration: 5000,
        });
        return;
      }
      this.isLoading = true;
      const payload = {
        bid_rate: price
      };
      const bidRateId = this.data?.bidRateId;
      this.service.updateBidRate(payload, this.token, bidRateId).subscribe(
        (response: any) => {
          this.isLoading = false;
          this.dialogRef.close({ event: "Success" });
        },
        (error: any) => {
          this.isLoading = false;
          if (error.status == 404) return;
          if (
            error.error.message === "jwt malformed" ||
            error.error.message === "jwt expired"
          ) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
            return;
          }
          this.snackBar.open(error.error.message || "Something went wrong", "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  // Method to restrict input to positive integers in real-time
  limitDecimalPlaces(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    const regex = /^\d*$/;

    if (regex.test(value)) {
      this.lastValidValue = value;
    } else {
      inputElement.value = this.lastValidValue;
      this.bidForm.get("rate")?.setValue(this.lastValidValue, { emitEvent: false });
    }
  }
}
